import { APP_INITIALIZER, Inject, Injectable, Injector, DOCUMENT } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BootstrapperBase } from '@trustedshops/tswp-core-common';
import { ProductFeatureUpgradePageComponent } from './product-feature-upgrade-page.component';

@Injectable()
export class ProductFeatureUpgradePageBootstrapper implements BootstrapperBase {
  public constructor(
    private readonly _injector: Injector,
    @Inject(DOCUMENT) private readonly _document: Document
  ) {}

  public async initialize(): Promise<void> {
    const defaultView = this._document.defaultView;
    if (!defaultView) {
      return;
    }
    const customElement = createCustomElement(ProductFeatureUpgradePageComponent, {
      injector: this._injector,
    });
    defaultView.customElements.define(
      ProductFeatureUpgradePageComponent.selector,
      customElement
    );
  }
}

export const ProductFeatureUpgradePageInitializer = [
  ProductFeatureUpgradePageBootstrapper,
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: (initializer: BootstrapperBase) => () => initializer.initialize(),
    deps: [ProductFeatureUpgradePageBootstrapper],
  },
];
